export const RATING_TAGS = {
  "sorprendente": { label: "Sorprendente", public: true },
  "buen-ritmo": { label: "Buen ritmo", public: true },
  "nos-hizo-hablar": { label: "Nos hizo hablar", public: true },
  "nos-hizo-reir": { label: "Nos hizo reír", public: true },
  "gran-atmosfera": { label: "Gran atmósfera", public: true },
  "reto-justo": { label: "Reto justo", public: true },
  "instrucciones-confusas": { label: "Instrucciones confusas", public: false },
  "ritmo-lento": { label: "Ritmo lento", public: false },
  "demasiado-dificil": { label: "Demasiado difícil", public: false },
  "problemas-tecnicos": { label: "Problemas técnicos", public: false }
} as const;

export type RatingTagId = keyof typeof RATING_TAGS;

export interface ExperienceRating {
  value: number;
  tags: RatingTagId[];
  updatedAt: string;
}

export interface RatingSummary {
  average: number | null;
  count: number;
  topTags: Array<{ id: RatingTagId; label: string; count: number }>;
}

export interface AdminRatingSummary extends RatingSummary {
  experienceId: string;
  title: string;
  distribution: Record<"1" | "2" | "3" | "4" | "5", number>;
  tags: Array<{ id: RatingTagId; label: string; count: number; public: boolean }>;
  versions: Array<{ version: string; average: number; count: number }>;
}

export function isRatingTagId(value: unknown): value is RatingTagId {
  return typeof value === "string" && value in RATING_TAGS;
}
